export let projectUser =
{
  key: "members", displayName: "Members", order: 1, type: "multiple-select", error: "", select: true,
  options: [], config: { "key": "name", "value": "_id" }, value: [], names: [], editMode: true
}


export let projectManager =
{
  key: "managers", displayName: "Managers", order: 1, type: "multiple-select", error: "", select: true,
  options: [], config: { "key": "name", "value": "_id" }, value: [], names: [], editMode: true
}
